import {track} from '@getmoss/moss-analytics'
import axios from 'axios'
import {useSearchParams} from 'next/navigation'
import {useCallback} from 'react'
import {useCookie} from 'react-use'
import {getUtmParams} from 'src/common/helpers'
import {useGetDomainCountry} from 'src/common/hooks/useGetDomainCountry'
import type {HubspotForm} from 'src/common/types'

const HUBSPOT_BASE_URL = 'https://api.hsforms.com/submissions/v3/integration/submit'

export const useHubspotTracking = (hubspotForm: HubspotForm) => {
  const [hutk] = useCookie('hubspotutk')
  const params = useSearchParams()
  const domainCountry = useGetDomainCountry()

  const trackHubspot = useCallback(
    async (data: {fields: {name: string; value: string}[]}) => {
      if (process.env.NODE_ENV !== 'production' || !hubspotForm?.portalId || !hubspotForm?.formId) {
        return
      }

      const preparedData = {
        submittedAt: new Date().getTime(),
        fields: [...data.fields, ...getUtmParams(params)],
        context: {
          pageUri: window.location.href,
          pageName: document.title,
          ...(hutk ? {hutk} : {}),
        },
      }

      try {
        const formUrl = `${HUBSPOT_BASE_URL}/${hubspotForm.portalId}/${hubspotForm.formId}`
        await axios.post(formUrl, preparedData)
      } catch (error) {
        track({
          event: 'interaction',
          interaction: {
            element: 'hubspot-form-error',
            location: 'hubspot-tracking-hook',
            type: 'error',
            elementText: JSON.stringify(error),
          },
          page: {
            type: 'useHubspotTracking',
            domainCountry,
          },
        })
      }
    },
    [domainCountry, hubspotForm.formId, hubspotForm.portalId, hutk, params],
  )

  return {trackHubspot}
}
